import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { UrlModal } from 'src/app/shared/url.model';
import { BehaviorSubject } from 'rxjs';
import * as moment from 'moment';
import { Token } from '@angular/compiler';

@Injectable({
  providedIn: 'root',
})
export class AppointmentService {
  URL = 'http://localhost:3005';
  //URL = "http://206.189.132.38:3005";

  constructor(private httpClient: HttpClient) {}

  saveAppointment(docId, patnum, patId, token, appDate, status) {
    return this.httpClient.post(
      UrlModal._URL + '/ap/saveappointment',
      {
        doctorId: docId,
        patientId: patId,
        patientNumber: patnum,
        appointmentDate: appDate,
        status: status,
      },
      {
        headers: new HttpHeaders({
          authorization: 'Bearer ' + token,
        }),
      }
    );
  }
  getPatientAppointment(patientId, token, page) {
    let params = new HttpParams();
    params = params.append('page', page);
    params = params.append('limit', '10');
    return this.httpClient
      .post<DocAppointmentData>(
        UrlModal._URL + '/ap/getpatientappointment',
        {
          patientId: patientId,
        },
        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + token,
          }),
          params: params,
        }
      )
      .pipe(
        map((resData) => {
          let appArray = [];

          appArray = resData.data.docs;

          return {
            appArray: appArray,
            page: resData.data.page,
            total: resData.data.total,
          };
        })
      );
  }
  getDoctorAppointment(id, token, page, clinicId) {
    let params = new HttpParams();
    params = params.append('page', page);
    params = params.append('limit', '10');
    return this.httpClient
      .post<DocAppointmentData>(
        UrlModal._URL + '/ap/docappointment/',
        {
          id: id,
          clinicId: clinicId,
        },

        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + token,
          }),
          params: params,
        }
      )
      .pipe(
        map((resData) => {
          let appArray = [];

          appArray = resData.data.docs.map((sinapp) => {
            const appointmentDate = sinapp.appointmentDate.split('T')[0];
            return { ...sinapp, appointmentDate };
          });

          return {
            appArray: appArray,
            page: resData.data.page,
            total: resData.data.total,
            limit:resData.data.limit
          };
        })
      );
  }
  getDoctorAppointmentByDate(appDate, docId, token, page, clinicId) {
    let params = new HttpParams();

    params = params.append('page', page);
    params = params.append('limit', '10');
    return this.httpClient
      .post<DocAppointmentData>(
        UrlModal._URL + '/ap/filterappointments',
        {
          doctorId: docId,
          appointmentDate: appDate.toString(),
          clinicId: clinicId,
        },
        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + token,
          }),
          params: params,
        }
      )
      .pipe(
        map((resData) => {
          let appArray = [];

          appArray = resData.data.docs.map((sinapp) => {
            const appointmentDate = sinapp.appointmentDate.split('T')[0];
            return { ...sinapp, appointmentDate };
          });

          return {
            appArray: appArray,
            limit:resData.data.limit,
            page: resData.data.page,
            total: resData.data.total,
          };
        })
      );
  }
  getDoctorSlotAppointmentByDate(payload) {
    let params = new HttpParams();

    params = params.append('page', payload.page);
    params = params.append('limit', '10');
    return this.httpClient
      .post<DocAppointmentData>(
        UrlModal._URL + '/ap/filterappointments',
        {
          doctorId: payload.docId,
          appointmentDate: payload.appDate.toString(),
          clinicId: payload.clinicId,
          slot:payload.slot?payload.slot:0
        },
        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + payload.token,
          }),
          params: params,
        }
      )
      .pipe(
        map((resData) => {
          let appArray = [];

          appArray = resData.data.docs.map((sinapp) => {
            const appointmentDate = sinapp.appointmentDate.split('T')[0];
            return { ...sinapp, appointmentDate };
          });

          return {
            appArray: appArray,
            limit:resData.data.limit,
            page: resData.data.page,
            total: resData.data.total,
          };
        })
      );
  }

  getDoctorAppointmentByDateAndStatus(
    appDate,
    docId,
    token,
    page,
    limit,
    clinicId
  ) {
    let params = new HttpParams();
    params = params.append('page', page);
    params = params.append('limit', limit);
    return this.httpClient
      .post<DocAppointmentData>(
        UrlModal._URL + '/ap/appointmentdashboard',
        {
          doctorId: docId,
          appointmentDate: appDate,
          clinicId: clinicId,
        },
        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + token,
          }),
          params: params,
        }
      )
      .pipe(
        map((resData) => {
          let appArray = [];

          appArray = resData.data.docs.map((sinapp) => {
            const appointmentDate = sinapp.appointmentDate.split('T')[0];
            return { ...sinapp, appointmentDate };
          });

          return {
            appArray: appArray,
            page: resData.data.page,
            total: resData.data.total,
          };
        })
      );
  }

  getPatientAppointmentByDate(appDate, patId, token, page) {
    let params = new HttpParams();
    params = params.append('page', page);
    params = params.append('limit', '10');
    return this.httpClient
      .post<DocAppointmentData>(
        UrlModal._URL + '/ap/patientappointmentbydate',
        {
          patientId: patId,
          appointmentDate: appDate,
        },
        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + token,
          }),
          params: params,
        }
      )
      .pipe(
        map((resData) => {
          let appArray = [];

          appArray = resData.data.docs.map((sinapp) => {
            const appointmentDate = sinapp.appointmentDate.split('T')[0];
            return { ...sinapp, appointmentDate };
          });

          return {
            appArray: appArray,
            page: resData.data.page,
            total: resData.data.total,
          };
        })
      );
  }

  getDoctorAppointmentByStatus(appDate, docId, token) {
    return this.httpClient
      .post<DocAppointmentData>(
        UrlModal._URL + '/ap/filterbystatus',
        {
          doctorId: docId,
          appointmentDate: appDate,
          status: 'CANCEL',
        },
        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + token,
          }),
        }
      )
      .pipe(
        map((resData) => {
          let appArray = [];

          appArray = resData.data.docs.map((sinapp) => {
            const appointmentDate = sinapp.appointmentDate.split('T')[0];
            return { ...sinapp, appointmentDate };
          });

          return appArray;
        })
      );
  }

  updatePatientStatus(
    docId: string,
    patientId: string,
    appointmentDate,
    token
  ) {
    return this.httpClient
      .post(
        UrlModal._URL + '/ap/appointmentstatus',
        {
          doctorId: docId,
          patientId: patientId,
          appointmentDate: appointmentDate,
        },
        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + token,
          }),
        }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  onConfirmStatus(
    patientId,
    appointmentDate,
    appointmentStatus,
    appointmentNumber,
    token,
    clinicId
  ) {
    console.log("this is pyload",clinicId);
    
    return this.httpClient
      .post(
        UrlModal._URL + '/ap/updatestatus',
        {
          patientId: patientId,
          appointmentDate: appointmentDate,
          appointmentStatus: appointmentStatus,
          appointmentNumber: appointmentNumber,
          clinicId:clinicId
        },
        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + token,
          }),
        }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  onConfirmallappointmentStatus(appointmentDate, token) {
    return this.httpClient
      .post(
        UrlModal._URL + '/ap/confirmallappointment',
        {
          appointmentDate: appointmentDate,
        },
        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + token,
          }),
        }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  cancelAllAppointment(appointmentDate, token) {
    return this.httpClient
      .post(
        UrlModal._URL + '/ap/cancelallappointment',
        {
          appointmentDate: appointmentDate,
        },
        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + token,
          }),
        }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  getAppointmentByAppNum(data,token) {
    return this.httpClient
      .post<appointmentData>(
        UrlModal._URL + '/ap/singleappointment',

        data,
        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + token,
          }),
        }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  getActiveAppointmentByAppNum(data,token) {
    return this.httpClient
      .post<appointmentData>(
        UrlModal._URL + '/ap/getactivepatient',

        data,
        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + token,
          }),
        }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  saveAppointmentStatusAppNum(
    appNum,
    token,
    date,
    doctorId,
    appStatus,
    clinicId
  ) {
    return this.httpClient
      .post<appointmentData>(
        UrlModal._URL + '/ap/singleappointmentstatus',

        {
          appointmentNumber:appNum,
          appointmentDate:date,
          doctorId:doctorId,
          clinicId:clinicId,
          appointmentStatus:appStatus
        },
        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + token,
          }),
        }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  searchPatByName(name, token, appointmentDate,clinicId) {
    console.log(clinicId)
    
    return this.httpClient
      .post<DocAppointmentData>(
        UrlModal._URL + '/ap/searchpatient',

        {
          name: name,
clinicId:clinicId,
          appointmentDate: appointmentDate.toString(),
        },
        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + token,
          }),
        }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  getnotPresentPat(docId,ClinicId,token,limit,page){
    let payload = {
      doctorId: docId,
      clinicId:ClinicId
    }
    return this.httpClient.post(UrlModal._URL+"/ap/notpresentpat?page="+page+"&limit="+limit,payload,
    {
      headers: new HttpHeaders({
        authorization: 'Bearer ' + token,
      }),
    }
    )
  }

  changeApptStatusByNum(clinicId,apptNumber,apptStatus,token){
    let payload = {
      clinicId:clinicId,
      apptNumber:apptNumber,
      apptStatus:apptStatus
    }
    return this.httpClient.post(UrlModal._URL+"/ap/changeApptStatusByNum",payload,
    {
      headers:new HttpHeaders({
        authorization: 'Bearer ' + token,
      }),
    })
  }

  GetrendomToken(ClinicId,token){
    let payload = {
      // token: this.token,
      clinicId:ClinicId
    }
    return this.httpClient.post(UrlModal._URL+"/ap/getTokensForAttempt",payload,
    {
      headers: new HttpHeaders({
        authorization: 'Bearer ' + token,
      }),
    }
    )
  }
  changeApptStatus(apptNum,date,docId,clinicId,apptStatus,token){
    let payload = {
      appointmentNumber:apptNum,
      appointmentDate:date,
      doctorId:docId,
      clinicId:clinicId,
      appointmentStatus:apptStatus
    }
    return this.httpClient.post(UrlModal._URL+"/ap/singleappointmentstatus",payload,
    {
      headers: new HttpHeaders({
        authorization: 'Bearer ' + token,
      }),
    }
    )
  }
  getSingleApptByappointmentId(apptId,token){
    return this.httpClient.get(UrlModal._URL+"/ap/getSingleApptByappointmentId/"+apptId,{
      headers: new HttpHeaders({
        authorization: 'Bearer ' + token,
      }),
    })
  }
  saveLabReport(apptId,token,patient,selectedFile,clinicId){
    var fm = new FormData();
    fm.append('patientName', patient.name);
    fm.append('patientPhoneNo', patient.phoneNo);
    fm.append('apptId',apptId);
    fm.append('clinicId',clinicId);
    fm.append('labReport',selectedFile);
    return this.httpClient.post(UrlModal._URL+"/lab/savelabreport",fm,{
      headers: new HttpHeaders({
        authorization: 'Bearer ' + token,
      }),
    })
  }
}

//singleappointmentstatus

//cancelallappointment

export interface appointmentData {
  status: number;
  message: string;
  appointment: {
    _id: string;
    isDeleted: boolean;
    isEnabled: boolean;
    doctorId: string;
    patientId: {
      _id: string;
      name: string;
      email: string;
      phoneNo: number;
    };
    appointmentDate: Date;
    appointementNumber: number;
    createdAt: string;
    updatedAt: string;
    __v: number;
  };
}
export interface DocAppointmentData {
  status: number;
  message: string;
  data: {
    docs: [
      {
        _id: string;
        isDeleted: boolean;
        isEnabled: boolean;
        doctorId: {
          _id: string;
          name: string;
          doctorType: string;
          email: string;
          phoneNo: number;
          degree: string;
        };
        patientId: {
          _id: string;
          isDeleted: boolean;
          isEnabled: boolean;
          name: string;
          email: string;
          phoneNo: number;
          createdAt: string;
          updatedAt: string;
          __v: number;
        };
        appointmentStatus: string;
        appointmentDate: string;
        appointmentNumber: number;
        createdAt: string;
        updatedAt: string;
        __v: number;
      }
    ];
    total: number;
    limit: number;
    page: number;
    pages: number;
  };
}
export interface patAppointmentData {
  status: number;
  message: string;
  data: [
    {
      _id: string;
      isDeleted: boolean;
      isEnabled: boolean;
      doctorId: {
        _id: string;
        name: string;
        doctorType: string;
        email: string;

        degree: string;
      };
      patientId: {
        _id: string;
        isDeleted: boolean;
        isEnabled: boolean;
        name: string;
        email: string;
        phoneNo: number;
        createdAt: string;
        updatedAt: string;
        __v: number;
      };
      appointmentStatus: string;
      appointmentDate: string;
      appointmentNumber: number;
      patientName: string;
      createdAt: string;
      updatedAt: string;
      __v: number;
    }
  ];
}
